import { Divider, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import { AiFillWarning } from "react-icons/ai";
import { FaHome } from "react-icons/fa";
import { HiDocumentSearch, HiLink } from "react-icons/hi";
import { MdEmail, MdHelp } from "react-icons/md";
import { RiUserSearchFill } from "react-icons/ri";
import DashboardButtons from "../../../components/Buttons/DashboardButtons";

export default function Dashboard() {
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaHome}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Service Portal</Heading>
                            <Text fontSize={'sm'}>Service Portal Management</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stack
                p={4}
                w={'98%'}
                spacing={4}
                rounded={'xl'}
                boxShadow={'base'}
                divider={<Divider />}
            >
                <Stack
                    spacing={2}
                >
                    <Heading fontSize={'2xl'}>Routine Tasks</Heading>
                    <Stack
                        w={'full'}
                        spacing={4}
                        direction={'row'}
                        justify={'space-between'}
                    >
                        <DashboardButtons
                            Icon={HiDocumentSearch}
                            text={'Document Review'}
                            to={'/internal/documents-review'}
                        />
                        <DashboardButtons
                            Icon={MdHelp}
                            text={'Categorization Help'}
                            to={'/internal/categorization-help'}
                        />
                        <DashboardButtons
                            Icon={RiUserSearchFill}
                            text={'User Activity'}
                            to={'/internal/users-activity'}
                        />
                        <DashboardButtons
                            Icon={HiLink}
                            text={'Integrated Past Data'}
                            to={'/internal/integrated-past-data'}
                        />
                    </Stack>
                </Stack>
                <Stack
                    spacing={2}
                >
                    <Heading fontSize={'2xl'}>Errors and Exceptions</Heading>
                    <Stack
                        w={'full'}
                        spacing={4}
                        direction={'row'}
                        justify={'space-between'}
                    >
                        <DashboardButtons
                            Icon={AiFillWarning}
                            bg={'gray.600'}
                            text={'Exception Management'}
                            _hover={{ bg: 'gray.700' }}
                            _active={{ bg: 'gray.800' }}
                            to={'/internal/exception-management'}
                        />
                        {/* <DashboardButtons
                            Icon={RiFolderWarningFill}
                            bg={'gray.600'}
                            text={'Export Errors'}
                            _hover={{ bg: 'gray.700' }}
                            _active={{ bg: 'gray.800' }}
                            to={'/internal/document-review'}
                        /> */}
                        <DashboardButtons
                            Icon={MdEmail}
                            bg={'gray.600'}
                            text={'Email Inbox'}
                            _hover={{ bg: 'gray.700' }}
                            _active={{ bg: 'gray.800' }}
                            to={'/internal/email-inbox'}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}